import EnercityAppButton from '@/page-templates/EnercityAppRedirectPage/EnercityAppButton';
import EnercityAppIcon from '../EnercityAppIcon/EnercityAppIcon';
import styles from './BenefitsAppTeaser.module.scss';

const BenefitsAppTeaser = () => {
  return (
    <div className={styles.base}>
      <div className={styles.iconWrapper}>
        <EnercityAppIcon />
      </div>
      <div className={styles.title}>
        Sichern Sie sich exklusive Vorteile in der enercity App
      </div>
      <div className={styles.buttons}>
        <EnercityAppButton variant="ios" name="Apple App Store" />
        <EnercityAppButton variant="android" name="Google Play Store" />
      </div>
    </div>
  );
};

export default BenefitsAppTeaser;
